import axios from 'axios';

export const api = {
  testiranja(){
    return axios.get(process.env.API_PATH+"/test",{
    })
  },
  test(naziv){
    return axios.post(process.env.API_PATH+"/test",{
      tip:naziv
    })
  },
  saveti(){
    return axios.get(process.env.API_PATH+"/saveti",{
    })
  },
  savet(naziv){
    return axios.post(process.env.API_PATH+"/saveti",{
      tip:naziv
    })
  },
  kurs(){
    return axios.get(process.env.API_PATH+"/kurs",{
    })
  },
  editpro(id){
  return axios.patch(process.env.API_PATH+"/allpro",{
    proid:id
  })
},
  setproduct(file){
var formData = new FormData();
 formData.append('naziv',file[0].naziv);
 formData.append('brand',file[0].brand);
 formData.append('opis',file[0].opis);
 formData.append('podkat',file[0].podkat);
 formData.append('cene',file[2]);
return axios.put(process.env.API_PATH+"/proizvodi" ,
formData ,
  {headers: {
'Content-Type' : 'multipart/form-data'
}})
},
updateproduct(file){
var formData = new FormData();
formData.append('proid',file.id);
formData.append('opis',file.opis);
for (var i = 0; i < file.slike.length; i++) {
    if(file.slike[i]){
    formData.append('images[]',file.slike[i]);
  }
}
return axios.post(process.env.API_PATH+"/updatepro" ,
formData ,
{headers: {
'Content-Type' : 'multipart/form-data'
}})
},
  proizvodi(){
    return axios.get(process.env.API_PATH+"/proizvodi",{
    })
  },
  pro(ime){
    return axios.post(process.env.API_PATH+"/proizvodi",{
      podime:ime
    })
  },
  podkat(id){
    return axios.post(process.env.API_PATH+"/allpro",{
      katid:id
    })
  },
  allpro(id){
    return axios.post(process.env.API_PATH+"/allpro",{
      podkatid:id
    })
  },
  singlpk(kid){
    return axios.post(process.env.API_PATH+"/singlpro",{
      proid:kid,
    })
  },
  insertpak(obj){
    return axios.put(process.env.API_PATH+"/pakovanje",{
      proid:obj[0],
      pakid:obj[1],
      paknaziv:obj[2],
      procena:obj[3]
    })
  },
  deletepak(id){
    return axios.delete(process.env.API_PATH+"/pakovanje",{
      params:{
        vezid:id
      }
    })
  },
  deletepro(id){
    return axios.delete(process.env.API_PATH+"/proizvodi",{
      params:{
        proid:id
      }
    })
  },
  pak(){
    return axios.patch(process.env.API_PATH+"/proizvodi",{
    })
  },
  brand(){
    return axios.post(process.env.API_PATH+"/brand",{
    })
  },
  images(id){
    return axios.post(process.env.API_PATH+"/productimg",{
      proid:id
    })
  },
  naruci(order){
    console.log(order);
    return axios.post(process.env.API_PATH+"/poruci",{
      pro:order
    })
  },
//   contacteng(user){
//     return axios.post(process.env.API_PATH+"/contacteng",{
//       user:user
//     })
//   },
//   putnews(email){
//         console.log(email);
//     return axios.put(process.env.API_PATH+"/contact",{
//       email:email
//     })
//   },
  // order(ord){
  //   return axios.post(process.env.API_PATH+"/order",{
  //     pro:ord
  //   })
  // },

//   checksession(sid){
//     return axios.post(process.env.API_PATH+"/isloged",{
//       sid: sid
//     })
//   },
//   fetchsearch(search){
//     return axios.post(process.env.API_PATH+"/search",{
//       catid:search.catid,
//       conid:search.conid,
//       name:search.name,
//     })
//   },
//   fetchcategories() {
//     return axios.get(process.env.API_PATH+"/getcategoryes",{
//     })
//   },
//   fetchconcern() {
//     return axios.get(process.env.API_PATH+"/getconcern",{
//
//     })
//   },
//   fetchproducts() {
//     return axios.post(process.env.API_PATH+"/products",{
//
//   })
// },
//   fetchpro() {
//     return axios.patch(process.env.API_PATH+"/products",{
//
//   })
// },
// fetchproduct(pro) {
//   return axios.post(process.env.API_PATH+"/singlpro",{
//     proid:pro.proid,
//     // mlid:pro.mlid
// })
// },
//   fetchml() {
//     return axios.get(process.env.API_PATH+"/ml",{
//     })
//   },
//   putproduct(pro){
//     var formData = new FormData();
//    formData.append('proname',pro.name);
//    formData.append('proeng',pro.texteng);
//    formData.append('prosrb',pro.textsrb);
//    formData.append('namena',pro.namena);
//    formData.append('purpose',pro.purpose);
//    formData.append('uput',pro.uput);
//    formData.append('inst',pro.inst);
//    formData.append('ime',pro.ime);
//    formData.append('sastav',pro.sastav);
//    formData.append('compose',pro.comp);
//     return axios.put(process.env.API_PATH+"/products" ,
//     formData ,
//       {headers: {
//     'Content-Type' : 'multipart/form-data'
//   }})
// },
// putimg(img){
//   var formData = new FormData();
//  formData.append('proimg',img.img);
//  formData.append('proid',img.proid);
//  formData.append('euro',img.euro);
//  formData.append('rsd',img.rsd);
//  formData.append('mlid',img.mlid);
//   return axios.put(process.env.API_PATH+"/productimg" ,
//   formData ,
//     {headers: {
//   'Content-Type' : 'multipart/form-data'
// }})
// },
//
//   logout(sid){
//
//   },
//   fetchtuts(payload){
//     return axios.post(process.env.API_PATH+"/gettuts",{
//       modid:payload.id,
//       catid:payload.cid
//     })
//   },
//   putcomments(payload){
//     console.log(payload)
//     return axios.post(process.env.API_PATH+"/comm",{
//       email:payload.email,
//       cname:payload.name,
//       star:payload.stars,
//       text:payload.text,
//       tutid:payload.tutid
//
//     })
//   },
}



// WEBPACK FOOTER //
// ./src/vuex/api/index.js